import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { alertNotification } from "../../../components/TopNotification/alertNotification";
import {
  getJobDetail,
  updateGig,
  deleteJob,
  clearJobDelSuccess,
  updateJobsReset,
  getJobBidDetails,
  postFavorites,
  deleteFavorites,
} from "../../../redux/actions";
import history from "../../../routes/history";
import { getImageByStateCode } from "../../CompanyProfile/components/cloudinary";
import {
  getAsRequiredForQuery,
  getExperienceLevelsArray,
  buildPiePlot,
} from "./jobDetailHelpers";
import { isRemoteJobLocation } from "../../../shared/helpers";

export default function useJobDetail(img) {
  const dispatch = useDispatch();
  const location = useLocation();

  const [showmodal, setshowmodal] = useState(false);
  const [isDisclaimer, setIsDisclaimer] = useState(false);
  const [favorite, setFavorite] = useState(false);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [piePlot, setpiePlot] = useState(null);

  const loader = useSelector((state) => state.updateGigReducer.loading);

  const deljobsuccess = useSelector(
    (state) => state.manageJobsReducer.del_success
  );

  const delete_job_response = useSelector(
    (state) => state.manageJobsReducer.response
  );

  const updateSuccess = useSelector((state) => state.UpdateJobReducer.success);

  const countDetails = useSelector(
    (state) => state.manageJobsReducer.bidDetails
  );

  const jobdetails = useSelector(
    (state) => state.getJobDetailReducer.jobdetails
  );

  const isFreePlan = useSelector((state) => {
    const cb = state.plansReducer?.creditsBalance;
    const p = cb?.data && typeof cb.data === "object" ? cb.data : cb || {};
    return p?.planCode === "Free";
  });

  const regionCode = jobdetails[0]?.Regions?.Code;
  const cityName = jobdetails[0]?.Cities?.CityName;
  const companyName = jobdetails[0]?.CompanyName;

  const bannerImg =
    img ||
    (regionCode && cityName && companyName
      ? getImageByStateCode(regionCode, cityName, companyName)
      : regionCode
        ? getImageByStateCode(regionCode, "state", companyName)
        : "");

  const locationDisplay =
    jobdetails[0]?.Location?.LocationWithCountry?.trim() ||
    (jobdetails?.length > 0 && isRemoteJobLocation(jobdetails[0]) ? "Remote" : "");

  const jobTypeName = jobdetails[0]?.JobOrderTypes?.JobOrderTypeName;

  const isContractType =
    jobTypeName === "Contract" || jobTypeName === "Contract Gig";

  const workplacePolicyDisplay = jobdetails[0]?.WorkplacePolicy?.trim()
    ? jobdetails[0].WorkplacePolicy.trim() === "on-prem"
      ? "On Premises"
      : jobdetails[0].WorkplacePolicy.trim().slice(0, 1).toUpperCase() +
      jobdetails[0].WorkplacePolicy.trim().slice(1)
    : "";

  const experienceLevelTags = getExperienceLevelsArray(jobdetails);

  const minExperience = jobdetails?.[0]?.minExperience ?? jobdetails[0]?.minExperience ?? null;
  const maxExperience = jobdetails?.[0]?.maxExperience ?? jobdetails[0]?.maxExperience ?? null;

  const rawBudgetMin = jobdetails?.[0]?.BudgetMin;
  const budgetMin =
    rawBudgetMin?.$numberDecimal != null
      ? Number(rawBudgetMin.$numberDecimal)
      : rawBudgetMin != null
        ? Number(rawBudgetMin)
        : null;

  const BUDGET_TYPE_LABEL = { hr: "hr", day: "day", wk: "week", mon: "month" };
  const budgetTypeCode = jobdetails?.[0]?.BudgetTypes?.BudgetTypeCode ?? null;
  const budgetTypeName = jobdetails?.[0]?.BudgetTypes?.BudgetTypeName ?? null;
  const budgetTypeLabel =
    (budgetTypeCode && BUDGET_TYPE_LABEL[budgetTypeCode]) ||
    (budgetTypeName ? budgetTypeName.toLowerCase() : null);

  console.info(jobdetails, "jobdetails in useJobDetail");
  const skills = jobdetails[0]?.JobOrders_Skills ?? [];

  useEffect(() => {
    const jobId = location.state?.id ?? window.location.pathname.split("jobdetail/")[1];
    const deleteJustSucceeded = delete_job_response?.status === 200;
    const isFirstLoad = delete_job_response?.status == null;

    dispatch(updateJobsReset());
    dispatch(getJobBidDetails(jobId));

    if (isFirstLoad || deleteJustSucceeded) {
      dispatch(getJobDetail(jobId));
    }
  }, [location.state?.id, delete_job_response?.status]);

  useEffect(() => {
    const job = jobdetails?.[0];
    if (!job) return;

    dispatch(clearJobDelSuccess());
    setpiePlot(buildPiePlot(jobdetails));
    if (job.JobOrderId != null) setFavorite(Boolean(job.IsFavorite));

    const tick = () => {
      if (job.JobOrderStatuses?.JobOrderStatusName === "Expired") {
        setDays(0);
        setHours(0);
        setMinutes(0);
        return;
      }
      const now = moment.utc();
      const expiry = moment.utc(job.ExpiryDate, "YYYY-MM-DD hh:mm");
      const diff = moment.utc(expiry - now);
      setDays(moment(expiry).diff(now, "days"));
      setHours(diff.format("HH"));
      setMinutes(diff.format("mm") % 60);
    };

    tick();
    const interval = setInterval(tick, 10000);
    return () => clearInterval(interval);
  }, [jobdetails]);


  const handleBack = () => {
    history.goBack();
  };

  const handleToggleFavorite = () => {
    const sourceId = jobdetails[0]?.JobOrderId;
    if (!sourceId) return;

    if (favorite) {
      dispatch(deleteFavorites(sourceId));
      setFavorite(false);
      alertNotification("success", "Job removed from favorites");
    } else {
      dispatch(postFavorites(sourceId));
      setFavorite(true);
      alertNotification("success", "Job added to favorites");
    }
  };

  const extendExp = () => {
    const extendedDate = new Date();
    extendedDate.setMonth(extendedDate.getMonth() + 1);

    dispatch(
      updateGig({
        Location: jobdetails[0]?.Location,
        ExpiryDate: extendedDate.toISOString(),
        JobOrderStatusName: "Published",
        id: location?.state?.id,
        onSuccess: () => {
          alertNotification("success", "Job expiry extended successfully");
          dispatch(
            getJobDetail(
              location.state?.id ??
              window.location.pathname?.split("jobdetail/")[1]
            )
          );
        },
      })
    );
  };

  const handleAISuggestion = () => {
    const isRemote =
      jobdetails?.[0]?.WorkplacePolicy == "fully-remote" ? true : false;
    const query = getAsRequiredForQuery({
      regions: isRemote ? undefined : jobdetails?.[0]?.Regions,
      countries: isRemote ? undefined : jobdetails?.[0]?.Countries,
      cities: isRemote ? undefined : jobdetails?.[0]?.Location,
      skills: jobdetails?.[0]?.JobOrders_Skills,
    });
    history.push(query);
  };

  const findMatches = () => {
    const job = jobdetails?.[0] || {};
    const title = job?.Title ?? "";

    const params = new URLSearchParams({ searchType: "Skills" });

    (job?.JobOrders_Skills ?? []).forEach((s) => {
      const name = s?.Skills?.SkillName ?? s?.SkillName;
      if (name) params.append("skill", name);
    });

    const jobLocation = job?.Location || {};
    const locationLabel =
      jobLocation?.LocationWithCountry ||
      jobLocation?.Location ||
      [jobLocation?.CityName || job?.Cities?.CityName, jobLocation?.RegionCode || job?.Regions?.Code]
        .filter(Boolean)
        .join(", ");

    if (locationLabel) params.append("location", locationLabel);
    if (jobLocation?.CityId) params.append("cityId", jobLocation.CityId);
    if (jobLocation?.RegionId) params.append("regionId", jobLocation.RegionId);
    if (jobLocation?.CountryId) params.append("countryId", jobLocation.CountryId);
    if (jobLocation?.CityName) params.append("cityName", jobLocation.CityName);
    if (jobLocation?.RegionName) params.append("regionName", jobLocation.RegionName);
    if (jobLocation?.CountryName) params.append("countryName", jobLocation.CountryName);

    (job?.ExperienceLevels ?? [])
      .map((e) => e.ExperienceLevelCode)
      .filter(Boolean)
      .map((code) => String(code))
      .map((code) => code === "20_100" ? code : code.replace(/_/g, "-"))
      .forEach((code) => params.append("yearsOfExp", code));

    (job?.ExperienceLevels ?? [])
      .map((e) => e.ExperienceLevelName)
      .filter(Boolean)
      .forEach((name) => params.append("experienceLevel", name));

    history.push(`/query/${encodeURIComponent(title)}?${params.toString()}`);
  };

  const DeleteJobHandler = () => {
    setshowmodal(true);
  };

  const skillDesitySplit = JSON.stringify(
    jobdetails[0]?.JobOrders_Skills?.map((item) => ({
      skillName: item?.Skills?.SkillName ?? item?.SkillName,
      SkillPercent: item?.SkillPercent,
      isDisable: true,
    }))
  );

  const industryDetailsForEdit = jobdetails[0]?.Industry?.map((item) => ({
    industryName: item.IndustryName,
    industryPercent: item.IndustryPercent ? item.IndustryPercent : 0,
    isDisable: true,
  }));

  const editJobSearch = `Title=${encodeURIComponent(
    jobdetails[0]?.Title
  )}&FacilityName=${jobdetails[0]?.FacilityName}&FromEdit=${true}&Location=${
    jobdetails[0]?.Location?.LocationWithCountry
  }&Experience=${JSON.stringify(
    jobdetails[0]?.ExperienceLevels
  )}&IdealContractLengthName=${
    jobdetails[0]?.IdealContractLength?.IdealContractLengthName
  }&JobOrderTypeName=${
    jobdetails[0]?.JobOrderTypes?.JobOrderTypeName
  }&Skills=${encodeURIComponent(skillDesitySplit)}&WorkAuthorization=${JSON.stringify(
    jobdetails[0]?.WorkAuthorization
  )}&openPositions=${jobdetails[0]?.Position}&certificates=${JSON.stringify(
    jobdetails[0]?.Certifications
  )}&locobj=${jobdetails[0]?.Cities}&Id=${
    jobdetails[0]?.JobOrderId
  }&NotTemplate=${true}&Industry=${JSON.stringify(industryDetailsForEdit)?.replace(
    /&/g,
    "ampersandd"
  )}&WorkPolicy=${jobdetails[0]?.WorkplacePolicy}&Description=${
    jobdetails[0]?.Description
  }&IdealTerms=${JSON.stringify(jobdetails[0]?.IdealTerms)}`;

  const EditJobHandler = () => {
    dispatch(updateJobsReset());
    if (!updateSuccess) {
      const job = jobdetails[0];
      history.push({
        pathname: "/create-job",
        state: {
          FromEdit: true,
          NotTemplate: true,
          Id: job?.JobOrderId,
          Title: job?.Title,
          FacilityName: job?.FacilityName,
          Location: job?.Location?.LocationWithCountry,
          locobj: job?.Cities,
          JobOrderTypeName: job?.JobOrderTypes?.JobOrderTypeName,
          IdealContractLengthName: job?.IdealContractLength?.IdealContractLengthName,
          ExperienceLevels: job?.ExperienceLevels,
          Skills: (job?.JobOrders_Skills || []).map((item) => ({
            skillName: item?.Skills?.SkillName ?? item?.SkillName,
            SkillPercent: item?.SkillPercent,
            isDisable: true,
          })),
          Industry: (job?.Industry || []).map((item) => ({
            industryName: item.IndustryName,
            industryPercent: item.IndustryPercent || 0,
            isDisable: true,
          })),
          WorkAuthorization: job?.WorkAuthorization,
          IdealTerms: job?.IdealTerms,
          openPositions: job?.Position,
          BudgetMin: job?.BudgetMin?.$numberDecimal != null
            ? Number(job.BudgetMin.$numberDecimal)
            : job?.BudgetMin != null ? Number(job.BudgetMin) : undefined,
          BudgetType: job?.BudgetTypes?.BudgetTypeName,
          workpolicy: job?.WorkplacePolicy,
          WorkPolicy: job?.WorkplacePolicy,
          Description: job?.Description,
          nl_description: job?.nl_description,
          isTemplate: job?.isTemplate || false,
          isPrivate: job?.isPrivate || false,
        },
      });
    }
  };

  const handleOk = () => {
    dispatch(deleteJob({ id: jobdetails[0].JobOrderId }));
    setshowmodal(false);
    setIsDisclaimer(true);
  };

  const handleCancel = () => {
    setshowmodal(false);
  };


  return {
    // State
    showmodal,
    setshowmodal,
    isDisclaimer,
    days,
    hours,
    minutes,
    piePlot,
    // Redux
    loader,
    deljobsuccess,
    delete_job_response,
    updateSuccess,
    countDetails,
    jobdetails,
    // Handlers
    handleBack,
    extendExp,
    handleAISuggestion,
    isFreePlan,
    findMatches,
    DeleteJobHandler,
    EditJobHandler,
    editJobSearch,
    handleOk,
    handleCancel,
    favorite,
    handleToggleFavorite,
    // Derived display values
    bannerImg,
    locationDisplay,
    jobTypeName,
    isContractType,
    workplacePolicyDisplay,
    experienceLevelTags,
    minExperience,
    maxExperience,
    skills,
    regionCode,
    companyName,
    budgetMin,
    budgetTypeName,
    budgetTypeLabel,
  };
}
